export function getDefaultItineraryStepHour(): number {
    const quotationCode = JSON.parse(localStorage.getItem('config') ?? '{}').quotation_code;

    if (quotationCode === 'beachcomber') {
        return 19;
    }

    return 9;
}